import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useFeatureToggleContext } from "contexts/FeatureToggleContext";
import { PatientDataList } from "routes/patients/PatientProfile/components/PatientHeader/PatientHeaderInfo/PatientDataList";
import { PatientStickyNote } from "routes/patients/PatientProfile/components/PatientHeader/PatientHeaderInfo/PatientStickyNote/PatientStickyNote";
import { Notification } from "shared/atoms/Notification";
import { SkeletonLayout } from "shared/atoms/SkeletonLayout";
import { Feature } from "utils/features/types";
import { useCurrentPatient } from "utils/hooks/useCurrentPatient";

export const PatientInfoPanel: React.FC = () => {
  const { t } = useTranslation();
  const { patientError: isError, patientLoading: isLoading } = useCurrentPatient();
  const { hasFeature } = useFeatureToggleContext();

  if (isLoading) {
    return (
      <SkeletonLayout
        layout={{
          type: "column",
          padding: 3,
          spacing: 2,
          children: [
            { type: "skeleton", variant: "rounded", width: "100%", height: 80 },
            { type: "skeleton", variant: "rounded", width: "100%", height: 280 },
            { type: "skeleton", variant: "rounded", width: "100%", height: 240 },
          ],
        }}
      />
    );
  }

  if (isError) {
    return (
      <Container>
        <Notification variant="danger">{t("errors.generic")}</Notification>
      </Container>
    );
  }

  return (
    <>
      <PatientDataList isCompactView />
      {hasFeature(Feature.PATIENT_STICKY_NOTE) && <PatientStickyNote isCompactView />}
    </>
  );
};

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
